module.exports = function (posts) {
	'use strict'
	posts.directive('setFeaturedImageModal', setFeaturedImageModal);
	setFeaturedImageModal.$inject = ['checkArray','keyPressOnlyNumber', 'authtokenService', 'getDataService', '$rootScope', 'activeClass', 'refreshtokenService', 'alertService', 'serverError', 'putDataService', 'postDataService', '$timeout','offlineError'];
	function setFeaturedImageModal(checkArray,keyPressOnlyNumber, authtokenService, getDataService, $rootScope, activeClass, refreshtokenService, alertService, serverError, putDataService, postDataService, $timeout, offlineError) {
		return {
			restrict: 'E',
			scope: {
				currentPostObj: "=",
				attachToPost:'='
			},
			template: require('./partial/setFeaturedImage.html'),
			link: function (scope, ele, $attrs, ctrl) {
				$rootScope.modalShow = true;
				var s;
				scope.pageNumber = 1;
				var state = 'attachments';
				var uploaded_to;
				var type = null;
				scope.currentPostObj.data_grid = [];
				scope.checkedTypeSearch = false;
				scope.emptyTable = false;
				scope.currentPostObj.changeImageTrue = false;
				scope.selectedAlign = { value: 'alignnone' };
				scope.selectedLink = { value: 'none' };
				scope.selectedAttachments = { value: 'all' };
				scope.customUrlShow = false;
				scope.changeFieldFlag = false;
				scope.currentPostObj.mediaLibrary = true;
				scope.attachToPostArray = [];
				scope.multiSelect = {};
				scope.unselectAll = true;
				scope.mediaItems = [];
				scope.galleryOrderArray = [];
				scope.searchDataImage = '';
				scope.gallery_title = scope.currentPostObj.gallery_title || '';
				scope.slideShowUnsafe = scope.currentPostObj.slideShowUnsafe;
				scope.onlyNumber = function (event) {
					keyPressOnlyNumber(event)
				}
				if(scope.currentPostObj.galleryUpdateIds && scope.currentPostObj.updateGallery) {
					getDataService.get({
						param1: state,
						ids: scope.currentPostObj.galleryUpdateIds
					}).$promise.then(function (data) {
						var orderArray = scope.currentPostObj.galleryUpdateIds.split(',');
						scope.attachToPostArray = checkArray.sortArrayByIdPredefined(data.attachments,orderArray)
						for(var i = 0; i<scope.attachToPostArray.length;i++) {
							scope.multiSelect[scope.attachToPostArray[i]._id] = true;
						}
					}, function (error) {
						if(!window.navigator.onLine) {
							offlineError()
							$rootScope.hasLoaded = true;
							return
						}
						if (error.status == 401) {
							var promise = refreshtokenService.getAccessToken();
							promise.then(
								function (answer) {
									if (answer == 200) {
										getimageLoadFunction();
									}
								},
								function (error) {
								},
								function (progress) {
									// report progress
								});
						} else if (error.status == 502) {
							serverError()
						} else {
							alertService('danger', 'Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
						}
					});
				}
				scope.addFileToPhotoLibrary = function(data) {
					$timeout(function(){
						scope.mediaItems.unshift(data.upload_data);
					},500)
				}
				scope.saveUploadedPhoto = function(data) {
					for (var i = 0; i < data.data.ids.length; i++) {
						for (var j = 0; j < scope.mediaItems.length; j++) {
							if (data.data.ids[i] == scope.mediaItems[j]._id) {
								if (data.data.description) {
									scope.mediaItems[j].description = data.data.description;
								}
								if (data.data.title) {
									scope.mediaItems[j].title = data.data.title;
								}
								if (data.data.gallery_title) {
									scope.mediaItems[j].gallery_title = data.data.gallery_title;
								}
								if (data.data.signature) {
									scope.mediaItems[j].signature = data.data.signature;
								}
								if (data.data.signature_url && scope.mediaItems[j].meta) {
									scope.mediaItems[j].meta.signature_url = data.data.signature_url;
								}
								break
							}
						}
					}
					for (var i = 0; i < scope.mediaItems.length; i++) {
						if (scope.multiSelect[i] == true) {
							scope.unselectAll = false;
						}
					}
				}
				scope.changeToInstertGallery = function () {
					// resetFunctionSelection();
				}
				// scope.$on('reset-selection', function (data) {
				// 	// resetFunctionSelection();
				// })
				scope.selectAllImagesFunction = function (model) {
					scope.attachToPostArray = [];
					for (var i = 0; i < scope.mediaItems.length; i++) {
						scope.multiSelect[scope.mediaItems[i]._id] = false;
						if (model) {
							scope.chooseImage(scope.mediaItems[i], i);
						} else {
							scope.unselectAll = true;
						}
					}
				}
				scope.changeAttachments = function (value) {
					if (!s) {
						type = null;
					} else {
						if (scope.checkedTypeSearch) {
							type = 'all';
						} else {
							type = null;
						}
					}
					jQuery(".grid").animate({
						scrollTop: 0
					}, 0);
					scope.pageNumber = 1;
					if (value == 'all') {
						uploaded_to = null;
						getimageLoadFunction();
					} else {
						uploaded_to = value
						getimageLoadFunction();
					}
				}
				var removeSelectedImageFunction = function (media) {
					for (var i = 0; scope.attachToPostArray.length; i++) {
						if (media._id == scope.attachToPostArray[i]._id) {
							scope.attachToPostArray.splice(i, 1);
							break
						}
					}
					scope.selectAllImages = false;
					scope.unselectAll = true;
				}
				scope.removeSelectedImage = function (media) {
					scope.multiSelect[media._id] = false;
					removeSelectedImageFunction(media);
				}
				scope.chooseImage = function (media, index) {
					if (media.restrictions) {
						if (media.restrictions.locked) return
					}
					if(media.status == 'lock') return
					if (scope.currentPostObj.insertMediatoEditor || scope.currentPostObj.insertGallery) {
						scope.selectedAlign = { value: 'alignnone' };
						scope.selectedLink = { value: 'none' };
						scope.customUrlShow = false;
						scope.unselectAll = true;
						scope.multiSelect[media._id] = !scope.multiSelect[media._id];
						scope.selectedImageObj = media;
						scope.selectedImageObj.align = scope.selectedAlign.value;
						scope.selectedImageObj.index = index;
						scope.changeLink = function (link) {
							if (link == 'url') {
								scope.customUrlShow = true;
								scope.selectedImageObj.link_to = 'https://';
							} else {
								scope.customUrlShow = false;
								scope.selectedImageObj.link_to = 'https://';
							}
						}
						scope.changeAlign = function (align) {
							scope.selectedImageObj.align = align;
						}
						if (scope.multiSelect[media._id] == true) {
							scope.unselectAll = false;
							scope.attachToPostArray.push(scope.selectedImageObj);
						} else {
							removeSelectedImageFunction(scope.selectedImageObj)
						}
					} else {
						scope.unselectAll = false;
						scope.selectedImage = media._id;
						scope.selectedImageObj = media;
					}
				}
				// scope.$on('reorder-images',function(event,data){
				// 	if(scope.attachToPostArray.length==0) return;
				// 	for(var i = 0 ;i < scope.attachToPostArray.length; i ++) {
				// 		for(var j = 0; j<data.mediaItems.length;j++) {
				// 			if(scope.attachToPostArray[i]._id == data.mediaItems[j]._id) {
				// 				scope.attachToPostArray[i].index = data.mediaItems[j].index							
				// 			}
				// 		}
				// 	}
				// })

				scope.setFeaturedImage = function () {
					scope.currentPostObj.featured_img_obj = scope.selectedImageObj;
					scope.currentPostObj.featured_img_id = scope.selectedImageObj._id;
					scope.currentPostObj.hasFeaturedImage = true;
					if (scope.current_id != scope.currentPostObj.featured_img_id) {
						scope.currentPostObj.changeImageTrue = true;
					}
				}
				scope.setShareImage = function () {
					scope.currentPostObj.shareImageObj = scope.selectedImageObj;
				}
				scope.postAttachFunction = function() {
					var postAttachFunction = function () {
						scope.idsToAttach = [];
						for (var i = 0; i < scope.attachToPostArray.length; i++) {
							scope.idsToAttach.push(scope.attachToPostArray[i]._id);
						}
						postDataService.save({
							param1: state,
							param2: 'attach',
							param3: scope.currentPostObj.postId
						}, {
								'ids': scope.idsToAttach
							}).$promise.then(function (data) {
								// alertService('success','Success ', data.message, 3000);
							}, function (error) {
								if (error.status == 401) {
									var promise = refreshtokenService.getAccessToken();
									promise.then(
										function (answer) {
											if (answer == 200) {
												postAttachFunction();
											}
										},
										function (error) {
											// report something
										},
										function (progress) {
											// report progress
										});
								} else if (error.status == 502) {
									serverError()
								} else {
									// alertService('danger','Opps! ', error.data.error.message);
								}
							});
					}
					if (scope.selectedAttachments.value == 'all') {
						postAttachFunction()
					}
				}
				scope.insertGallery = function() {
					if (scope.attachToPostArray.length > 0) {
						// scope.attachToPostArray = scope.attachToPostArray.sort(function(obj1, obj2){
						//              return  obj1.index - obj2.index
						//          });
						scope.attachToPostArrayIds = [];
						for (var i = 0; i < scope.attachToPostArray.length; i++) {
							scope.attachToPostArrayIds.push(scope.attachToPostArray[i]._id)
						}
						scope.$parent.$parent.$broadcast('insert-gallery', { 
							attachments_ids: scope.attachToPostArrayIds, 
							gallery_title:scope.gallery_title,
							slideShowUnsafe: scope.slideShowUnsafe, 
							update:(scope.currentPostObj.updateGallery)?true:false});
						$timeout(function () {
							scope.currentPostObj.cancelImageModal()
						}, 0)
					} else {
						alertService('danger', 'Opps! ', 'Image is not selected');
					}
					if(scope.attachToPost) {
						scope.postAttachFunction()
					}
				}
				scope.insertMediaToEditor = function () {
					if (scope.attachToPostArray.length > 0) {
						for (var i = 0; i < scope.attachToPostArray.length; i++) {
							if (!scope.attachToPostArray[i].signature) {
								scope.selectedImageObj = scope.attachToPostArray[i];
								alertService('danger', 'Opps! ', 'Image (title:' + scope.attachToPostArray[i].title + ') does not have signature');
								return false
							}
							if (scope.attachToPostArray[i].link_to == 'https://') {
								scope.attachToPostArray[i].link_to = null;
							};
						}
						// scope.attachToPostArray = scope.attachToPostArray.sort(function(obj1, obj2){
						//              return  obj1.index - obj2.index
						//          });
						scope.$parent.$parent.$broadcast('add-media-to-editor', { insertMediaArray: scope.attachToPostArray });
						$timeout(function () {
							scope.currentPostObj.cancelImageModal()
						}, 0)
					} else {
						alertService('danger', 'Opps! ', 'Image is not selected');
					}
					if(scope.attachToPost) {
						scope.postAttachFunction()
					} 
				}
				// scope.reorderImage = function() {

				// }
				// scope.changeMediaAction = function (event, actionMedia) {
				// 	resetRestrictionFunction();
				// 	activeClass.active(event);
				// 	if (actionMedia == 'insert-media') {
				// 		scope.currentPostObj.insertMediatoEditor = true;
				// 		scope.currentPostObj.setFeaturedImage = false;
				// 	} else if (actionMedia == 'set-featured-image') {
				// 		scope.currentPostObj.setFeaturedImage = true;
				// 		scope.currentPostObj.insertMediatoEditor = false;
				// 		$timeout(function () {
				// 			scope.chooseImage(scope.mediaItems[0], 0);
				// 		}, 0);
				// 	}
				// }
				scope.searchEmpty = function (value) {
					if (value.length == 0) {
						$timeout(function () {
							scope.search(value)
						}, 0)
					}
				}
				scope.search = function (value) {
					if (scope.checkedTypeSearch) {
						type = 'all';
					} else {
						type = null;
					}
					if (value.length > 0) {
						s = value.toLowerCase();
					} else if (value.length == 0) {
						s = null;
						type = null;
					}
					jQuery(".grid").animate({
						scrollTop: 0
					}, 0);
					scope.pageNumber = 1;
					getimageLoadFunction();
				}
				var deleteFunction = function (post) {
					putDataService.update({
						param1: state,
						param2: 'bulk',
						param3: 'delete'
					}, {
							'delete_ids': scope.mediaIds,
						}).$promise.then(function (bulkDelete) {
							if(post.featuredImage) {
								$timeout(function() {
									scope.currentPostObj.removeFeaturedImage();

								},0)
							}
							if(post.shareImage) {
								$timeout(function() {
									scope.currentPostObj.removeShareImage();

								},0)
							}
							removeSelectedImageFunction(post);
							$rootScope.hasLoaded = true;
							getimageLoadFunction();
							scope.$broadcast('delete-photo-from-upload',{id:scope.mediaIds[0]});
							scope.mediaIds = null;
							scope.unselectAll = true;
							alertService('success', 'SUCCESS ', bulkDelete.message, 2000);
						}, function (error) {
							if(!window.navigator.onLine) {
								offlineError()
								$rootScope.hasLoaded = true;
								alertService('danger','Opps! ', 'Please check your internet connection and try again.');
								return
							}
							if (error.status == 401) {
								var promise = refreshtokenService.getAccessToken();
								promise.then(
									function (answer) {
										if (answer == 200) {
											putFunction();
										}
									},
									function (error) {
										// report something
									},
									function (progress) {
										// report progress
									});
							} else if (error.status == 502) {
								serverError();
							} else {
								alertService('danger', 'Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
							}
							$rootScope.hasLoaded = true;
						});
				}
				scope.deleteMedia = function (post) {
					$rootScope.hasLoaded = false;
					scope.mediaIds = [post._id];
					deleteFunction(post);
				}
				var postFunction = function () {
					$rootScope.hasLoaded = false;
					postDataService.save({
						param1: state,
						param2: 'update',
						id: scope.selectedImageObj._id
					}, {
							'title': scope.selectedImageObj.title,
							'signature': scope.selectedImageObj.signature,
							'image_alt': scope.selectedImageObj.image_alt,
							'description': scope.selectedImageObj.description,
							'signature_url': scope.selectedImageObj.meta.signature_url,
							'gallery_title': scope.selectedImageObj.gallery_title
						}).$promise.then(function (data) {
							$rootScope.hasLoaded = true;
							alertService('success', 'SUCCESS ', data.message, 2000);
						}, function (error) {
							if(!window.navigator.onLine) {
								offlineError()
								$rootScope.hasLoaded = true;
								alertService('danger','Opps! ', 'Please check your internet connection and try again.');
								return
							}
							if (error.status == 401) {
								var promise = refreshtokenService.getAccessToken();
								promise.then(
									function (answer) {
										if (answer == 200) {
											postFunction();
										}
									},
									function (error) {
										// report something
									},
									function (progress) {
										// report progress
									});
							} else if (error.status == 502) {
								serverError()
							} else {
								alertService('danger', 'Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
							}
							$rootScope.hasLoaded = true;
						});
				}
				scope.changeField = function () {
					scope.changeFieldFlag = true;
				}
				scope.outFocus = function () {
					if (scope.changeFieldFlag) {
						$rootScope.hasLoaded = false;
						scope.changeFieldFlag = false;
						postFunction();
					}
				}
				var getimageLoadFunction = function () {
					$rootScope.hasLoaded = false;
					getDataService.get({
						param1: state,
						param2: null,
						limit: 100,
						page: scope.pageNumber,
						s: s,
						type: type,
						uploaded_to: uploaded_to,
						sortby: (scope.selectedAttachments.value != 'all') ? 'order' : null
					}).$promise.then(function (data) {
						$rootScope.hasLoaded = true;
						scope.emptyTable = false;
						// resetFunctionSelection();
						scope.mediaItems = data.attachments;

						scope.maxPages = data.max_pages;
						if (!s && scope.selectedAttachments.value == 'all' && !scope.currentPostObj.insertMediatoEditor && !scope.currentPostObj.insertGallery) {
							var currentObj;
							if(scope.currentPostObj.featured_img_obj && scope.currentPostObj.setFeaturedImage) {
								scope.current_id = scope.currentPostObj.featured_img_obj._id
								currentObj = scope.currentPostObj.featured_img_obj
								scope.currentPostObj.featured_img_obj.featuredImage = true;
							} else if(scope.currentPostObj.setShareImage && scope.currentPostObj.shareImageObj) {
								currentObj = scope.currentPostObj.shareImageObj
								scope.currentPostObj.shareImageObj.shareImage = true;
							}
							if(currentObj) {
								for (var i = 0; i < scope.mediaItems.length; i++) {
									if (currentObj._id == scope.mediaItems[i]._id) {
										scope.mediaItems.splice(i, 1);
										break
									}
								}
								scope.mediaItems.unshift(currentObj);
							}
						}
						if (!scope.currentPostObj.insertMediatoEditor && !scope.currentPostObj.insertGallery) {
							scope.unselectAll = false;
							$timeout(function () {
								scope.chooseImage(scope.mediaItems[0], 0);
								if(scope.currentPostObj.featured_img_obj && !s && scope.currentPostObj.featured_img_obj.status =='lock') {
									scope.chooseImage(scope.mediaItems[1], 1);
								}
							}, 0);
						}
					}, function (error) {
						if(!window.navigator.onLine) {
							offlineError()
							$rootScope.hasLoaded = true;
							return
						}
						if (error.status == 401) {
							var promise = refreshtokenService.getAccessToken();
							promise.then(
								function (answer) {
									if (answer == 200) {
										getimageLoadFunction();
									}
								},
								function (error) {
								},
								function (progress) {
									// report progress
								});
						} else if (error.status == 502) {
							serverError()
						} else if (error.status == 404) {
							// resetFunctionSelection();
							scope.emptyTable = true;
							scope.mediaItems = [];
						} else {
							scope.mediaItems = [];
							alertService('danger', 'Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
						}
						$rootScope.hasLoaded = true;
					});
				}
				getimageLoadFunction();
			}
		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/postsModule/edit-newpost/js/directive/setFeaturedImageDirective.js
// module id = 562
// module chunks = 0